export default {
  ATTACH_BRACES_NOTES: 'ATTACH_BRACES_NOTES',
  VIEW_SUMMARY: 'VIEW_SUMMARY',
  EDIT: 'EDIT',
  DELETE_APPOINTMENT: 'DELETE_APPOINTMENT',
} as const
